declare namespace $ {

	type $mol_labeler__title_bog_gamengine_demo_jumper_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gamengine_demo_jumper_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_bog_gamengine_demo_jumper_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gamengine_demo_jumper_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_check_box__title_bog_gamengine_demo_jumper_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_gamengine_demo_jumper_6 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['screen_shown'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $bog_gamengine_draw__scene_bog_gamengine_demo_jumper_7 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Scene'] >
		,
		ReturnType< $bog_gamengine_draw['scene'] >
	>
	type $bog_gamengine_draw__cam_bog_gamengine_demo_jumper_8 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Cam'] >
		,
		ReturnType< $bog_gamengine_draw['cam'] >
	>
	type $bog_gamengine_input_screen__shown_bog_gamengine_demo_jumper_9 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['screen_shown'] >
		,
		ReturnType< $bog_gamengine_input_screen['shown'] >
	>
	type $bog_gamengine_input_screen__actions_bog_gamengine_demo_jumper_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_gamengine_input_screen['actions'] >
	>
	type $bog_gamengine_input_screen__titles_bog_gamengine_demo_jumper_11 = $mol_type_enforce<
		({ 
			'jump': string,
		}) 
		,
		ReturnType< $bog_gamengine_input_screen['titles'] >
	>
	type $mol_view__sub_bog_gamengine_demo_jumper_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_bog_gamengine_demo_jumper_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_gamengine_demo_jumper_14 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['restart'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_page__title_bog_gamengine_demo_jumper_15 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['end_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_bog_gamengine_demo_jumper_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__foot_bog_gamengine_demo_jumper_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['foot'] >
	>
	type $mol_view__sub_bog_gamengine_demo_jumper_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_demo_jumper_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_demo_jumper_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_gamengine_phys__bodies_bog_gamengine_demo_jumper_21 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['bodies'] >
		,
		ReturnType< $bog_gamengine_phys['bodies'] >
	>
	type $bog_gamengine_phys__tile_bog_gamengine_demo_jumper_22 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Tile'] >
		,
		ReturnType< $bog_gamengine_phys['tile'] >
	>
	type $bog_gamengine_batch__shader_bog_gamengine_demo_jumper_23 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Sprite_shader'] >
		,
		ReturnType< $bog_gamengine_batch['shader'] >
	>
	type $bog_gamengine_batch__atlas_bog_gamengine_demo_jumper_24 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Atlas'] >
		,
		ReturnType< $bog_gamengine_batch['atlas'] >
	>
	type $bog_gamengine_batch__nodes_bog_gamengine_demo_jumper_25 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['sprites'] >
		,
		ReturnType< $bog_gamengine_batch['nodes'] >
	>
	type __bog_gamengine_demo_jumper_26 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_jumper['hero_lives'] >[0]
		,
		Parameters< ReturnType< $bog_gamengine_demo_jumper['Hero'] >['lives'] >[0]
	>
	type __bog_gamengine_demo_jumper_27 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_jumper['hero_coins'] >[0]
		,
		Parameters< ReturnType< $bog_gamengine_demo_jumper['Hero'] >['coins'] >[0]
	>
	type __bog_gamengine_demo_jumper_28 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_jumper['hero_won'] >[0]
		,
		Parameters< ReturnType< $bog_gamengine_demo_jumper['Hero'] >['won'] >[0]
	>
	type __bog_gamengine_demo_jumper_29 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_jumper['hero_face_left'] >[0]
		,
		Parameters< ReturnType< $bog_gamengine_demo_jumper['Hero'] >['face_left'] >[0]
	>
	type __bog_gamengine_demo_jumper_30 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_jumper['hero_clip'] >[0]
		,
		Parameters< ReturnType< $bog_gamengine_demo_jumper['Hero'] >['clip'] >[0]
	>
	type __bog_gamengine_demo_jumper_31 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_jumper['item_taken'] >[0]
		,
		Parameters< $bog_gamengine_demo_jumper['Item'] >[0]
	>
	type __bog_gamengine_demo_jumper_32 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_jumper['item_taken'] >[1]
		,
		Parameters< $bog_gamengine_demo_jumper['Item'] >[0]
	>
	type __bog_gamengine_demo_jumper_33 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_jumper['enemy_dead'] >[0]
		,
		Parameters< $bog_gamengine_demo_jumper['Enemy'] >[0]
	>
	type __bog_gamengine_demo_jumper_34 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_jumper['enemy_dead'] >[1]
		,
		Parameters< $bog_gamengine_demo_jumper['Enemy'] >[0]
	>
	type __bog_gamengine_demo_jumper_35 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_jumper['enemy_face_left'] >[0]
		,
		Parameters< $bog_gamengine_demo_jumper['Enemy'] >[0]
	>
	type __bog_gamengine_demo_jumper_36 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_jumper['enemy_face_left'] >[1]
		,
		Parameters< $bog_gamengine_demo_jumper['Enemy'] >[0]
	>
	type $bog_gamengine_demo_jumper_level__tile_bog_gamengine_demo_jumper_37 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Tile'] >
		,
		ReturnType< $bog_gamengine_demo_jumper_level['tile'] >
	>
	type $bog_gamengine_phys_tile__map_bog_gamengine_demo_jumper_38 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['map'] >
		,
		ReturnType< $bog_gamengine_phys_tile['map'] >
	>
	type $bog_gamengine_phys_tile__solid_bog_gamengine_demo_jumper_39 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_phys_tile['solid'] >
	>
	type $bog_gamengine_atlas__uris_bog_gamengine_demo_jumper_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_gamengine_atlas['uris'] >
	>
	type $bog_gamengine_atlas__size_bog_gamengine_demo_jumper_41 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_atlas['size'] >
	>
	type $bog_gamengine_sound__uris_bog_gamengine_demo_jumper_42 = $mol_type_enforce<
		({ 
			'jump': string,
			'coin': string,
			'death': string,
		}) 
		,
		ReturnType< $bog_gamengine_sound['uris'] >
	>
	type $bog_gamengine_key__bind_bog_gamengine_demo_jumper_43 = $mol_type_enforce<
		({ 
			'left': readonly(any)[],
			'right': readonly(any)[],
			'jump': readonly(any)[],
		}) 
		,
		ReturnType< $bog_gamengine_key['bind'] >
	>
	type $bog_gamengine_input__key_bog_gamengine_demo_jumper_44 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Key'] >
		,
		ReturnType< $bog_gamengine_input['key'] >
	>
	type $bog_gamengine_input__screen_bog_gamengine_demo_jumper_45 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Screen'] >
		,
		ReturnType< $bog_gamengine_input['screen'] >
	>
	type $bog_gamengine_scene__clock_bog_gamengine_demo_jumper_46 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Clock'] >
		,
		ReturnType< $bog_gamengine_scene['clock'] >
	>
	type $bog_gamengine_scene__input_bog_gamengine_demo_jumper_47 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Input'] >
		,
		ReturnType< $bog_gamengine_scene['input'] >
	>
	type $bog_gamengine_scene__kids_bog_gamengine_demo_jumper_48 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['nodes'] >
		,
		ReturnType< $bog_gamengine_scene['kids'] >
	>
	type $bog_gamengine_scene__phys_bog_gamengine_demo_jumper_49 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Phys'] >
		,
		ReturnType< $bog_gamengine_scene['phys'] >
	>
	type $bog_gamengine_scene__batches_bog_gamengine_demo_jumper_50 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_gamengine_scene['batches'] >
	>
	type $bog_gamengine_cam_flat__height_bog_gamengine_demo_jumper_51 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['cam_height'] >
		,
		ReturnType< $bog_gamengine_cam_flat['height'] >
	>
	type $bog_gamengine_cam_flat__target_bog_gamengine_demo_jumper_52 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Hero'] >
		,
		ReturnType< $bog_gamengine_cam_flat['target'] >
	>
	type $bog_gamengine_cam_flat__bounds_bog_gamengine_demo_jumper_53 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['cam_bounds'] >
		,
		ReturnType< $bog_gamengine_cam_flat['bounds'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_jumper_54 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_jumper_55 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_sprite__pos_bog_gamengine_demo_jumper_56 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['sky_pos'] >
		,
		ReturnType< $bog_gamengine_sprite['pos'] >
	>
	type $bog_gamengine_sprite__size_bog_gamengine_demo_jumper_57 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['sky_size'] >
		,
		ReturnType< $bog_gamengine_sprite['size'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_jumper_58 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_jumper_59 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['cell_frame'] >
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_sprite__pos_bog_gamengine_demo_jumper_60 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['cell_pos'] >
		,
		ReturnType< $bog_gamengine_sprite['pos'] >
	>
	type $bog_gamengine_demo_jumper_hero__input_bog_gamengine_demo_jumper_61 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Input'] >
		,
		ReturnType< $bog_gamengine_demo_jumper_hero['input'] >
	>
	type $bog_gamengine_demo_jumper_hero__sound_bog_gamengine_demo_jumper_62 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Sound'] >
		,
		ReturnType< $bog_gamengine_demo_jumper_hero['sound'] >
	>
	type $bog_gamengine_demo_jumper_hero__start_bog_gamengine_demo_jumper_63 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['hero_start'] >
		,
		ReturnType< $bog_gamengine_demo_jumper_hero['start'] >
	>
	type $bog_gamengine_demo_jumper_hero__pos_bog_gamengine_demo_jumper_64 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['hero_pos'] >
		,
		ReturnType< $bog_gamengine_demo_jumper_hero['pos'] >
	>
	type $bog_gamengine_sprite__parent_bog_gamengine_demo_jumper_65 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Hero'] >
		,
		ReturnType< $bog_gamengine_sprite['parent'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_jumper_66 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_jumper_67 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_sprite__flip_x_bog_gamengine_demo_jumper_68 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['hero_face_left'] >
		,
		ReturnType< $bog_gamengine_sprite['flip_x'] >
	>
	type $bog_gamengine_sprite__clock_bog_gamengine_demo_jumper_69 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Clock'] >
		,
		ReturnType< $bog_gamengine_sprite['clock'] >
	>
	type $bog_gamengine_sprite__clip_bog_gamengine_demo_jumper_70 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['hero_clip'] >
		,
		ReturnType< $bog_gamengine_sprite['clip'] >
	>
	type $bog_gamengine_sprite__fps_bog_gamengine_demo_jumper_71 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_sprite['fps'] >
	>
	type $bog_gamengine_sprite__clips_bog_gamengine_demo_jumper_72 = $mol_type_enforce<
		({ 
			'walk': readonly(any)[],
		}) 
		,
		ReturnType< $bog_gamengine_sprite['clips'] >
	>
	type $bog_gamengine_demo_jumper_item__role_bog_gamengine_demo_jumper_73 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['item_role'] >
		,
		ReturnType< $bog_gamengine_demo_jumper_item['role'] >
	>
	type $bog_gamengine_demo_jumper_item__pos_bog_gamengine_demo_jumper_74 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['item_pos'] >
		,
		ReturnType< $bog_gamengine_demo_jumper_item['pos'] >
	>
	type $bog_gamengine_sprite__parent_bog_gamengine_demo_jumper_75 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Item'] >
		,
		ReturnType< $bog_gamengine_sprite['parent'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_jumper_76 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_jumper_77 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['item_role'] >
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_demo_jumper_enemy__tile_bog_gamengine_demo_jumper_78 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Tile'] >
		,
		ReturnType< $bog_gamengine_demo_jumper_enemy['tile'] >
	>
	type $bog_gamengine_demo_jumper_enemy__pos_bog_gamengine_demo_jumper_79 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['enemy_pos'] >
		,
		ReturnType< $bog_gamengine_demo_jumper_enemy['pos'] >
	>
	type $bog_gamengine_demo_jumper_enemy__brain_bog_gamengine_demo_jumper_80 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Brain'] >
		,
		ReturnType< $bog_gamengine_demo_jumper_enemy['brain'] >
	>
	type $bog_gamengine_demo_jumper_enemy__kids_bog_gamengine_demo_jumper_81 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['enemy_kids'] >
		,
		ReturnType< $bog_gamengine_demo_jumper_enemy['kids'] >
	>
	type $bog_gamengine_sprite__parent_bog_gamengine_demo_jumper_82 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Enemy'] >
		,
		ReturnType< $bog_gamengine_sprite['parent'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_jumper_83 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_jumper_84 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_sprite__flip_x_bog_gamengine_demo_jumper_85 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['enemy_face_left'] >
		,
		ReturnType< $bog_gamengine_sprite['flip_x'] >
	>
	type $bog_gamengine_brain_fsm__owner_bog_gamengine_demo_jumper_86 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['Enemy'] >
		,
		ReturnType< $bog_gamengine_brain_fsm['owner'] >
	>
	type $bog_gamengine_brain_fsm__kids_bog_gamengine_demo_jumper_87 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['brain_kids'] >
		,
		ReturnType< $bog_gamengine_brain_fsm['kids'] >
	>
	type $bog_gamengine_brain_state__name_bog_gamengine_demo_jumper_88 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_brain_state['name'] >
	>
	type $bog_gamengine_brain_state__next_bog_gamengine_demo_jumper_89 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['walk_right_next'] >
		,
		ReturnType< $bog_gamengine_brain_state['next'] >
	>
	type $bog_gamengine_brain_state__name_bog_gamengine_demo_jumper_90 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_brain_state['name'] >
	>
	type $bog_gamengine_brain_state__next_bog_gamengine_demo_jumper_91 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_jumper['walk_left_next'] >
		,
		ReturnType< $bog_gamengine_brain_state['next'] >
	>
	export class $bog_gamengine_demo_jumper extends $mol_page {
		lives_stat( ): string
		Lives( ): $mol_labeler
		coins_stat( ): string
		Coins( ): $mol_labeler
		screen_shown( next?: boolean ): boolean
		Screen_switch( ): $mol_check_box
		stat( ): ReturnType< ReturnType< $bog_gamengine_demo_jumper['Draw'] >['stat'] >
		draw_width( ): ReturnType< ReturnType< $bog_gamengine_demo_jumper['Draw'] >['width'] >
		draw_height( ): ReturnType< ReturnType< $bog_gamengine_demo_jumper['Draw'] >['height'] >
		Draw( ): $bog_gamengine_draw
		Screen( ): $bog_gamengine_input_screen
		end_title( ): string
		end_hint( ): string
		End_hint( ): $mol_view
		restart( next?: any ): any
		Again( ): $mol_button_major
		End( ): $mol_page
		game( ): readonly(any)[]
		time_stat( ): string
		Time( ): $mol_view
		hero_stat( ): string
		Hero_stat( ): $mol_view
		Stat( ): $mol_view
		nodes( ): readonly(any)[]
		bodies( ): readonly(any)[]
		Phys( ): $bog_gamengine_phys
		Sprite_shader( ): $bog_gamengine_shader_sprite
		sprites( ): readonly(any)[]
		Batch( ): $bog_gamengine_batch
		cam_height( ): number
		cam_bounds( ): Float32Array
		sky_pos( ): Float32Array
		sky_size( ): Float32Array
		cell_frame( id: any): string
		cell_pos( id: any): Float32Array
		hero_start( ): Float32Array
		hero_pos( next?: Float32Array ): Float32Array
		hero_lives( next?: ReturnType< ReturnType< $bog_gamengine_demo_jumper['Hero'] >['lives'] > ): ReturnType< ReturnType< $bog_gamengine_demo_jumper['Hero'] >['lives'] >
		hero_coins( next?: ReturnType< ReturnType< $bog_gamengine_demo_jumper['Hero'] >['coins'] > ): ReturnType< ReturnType< $bog_gamengine_demo_jumper['Hero'] >['coins'] >
		hero_won( next?: ReturnType< ReturnType< $bog_gamengine_demo_jumper['Hero'] >['won'] > ): ReturnType< ReturnType< $bog_gamengine_demo_jumper['Hero'] >['won'] >
		hero_face_left( next?: ReturnType< ReturnType< $bog_gamengine_demo_jumper['Hero'] >['face_left'] > ): ReturnType< ReturnType< $bog_gamengine_demo_jumper['Hero'] >['face_left'] >
		hero_clip( next?: ReturnType< ReturnType< $bog_gamengine_demo_jumper['Hero'] >['clip'] > ): ReturnType< ReturnType< $bog_gamengine_demo_jumper['Hero'] >['clip'] >
		item_role( id: any): string
		item_pos( id: any): Float32Array
		item_taken( id: any, next?: ReturnType< ReturnType< $bog_gamengine_demo_jumper['Item'] >['taken'] > ): ReturnType< ReturnType< $bog_gamengine_demo_jumper['Item'] >['taken'] >
		enemy_pos( id: any, next?: Float32Array ): Float32Array
		enemy_kids( id: any): readonly(any)[]
		enemy_dead( id: any, next?: ReturnType< ReturnType< $bog_gamengine_demo_jumper['Enemy'] >['dead'] > ): ReturnType< ReturnType< $bog_gamengine_demo_jumper['Enemy'] >['dead'] >
		enemy_face_left( id: any, next?: ReturnType< ReturnType< $bog_gamengine_demo_jumper['Enemy'] >['face_left'] > ): ReturnType< ReturnType< $bog_gamengine_demo_jumper['Enemy'] >['face_left'] >
		brain_kids( id: any): readonly(any)[]
		walk_right_next( ): readonly(any)[]
		walk_left_next( ): readonly(any)[]
		title( ): string
		tools( ): readonly(any)[]
		body( ): ReturnType< $bog_gamengine_demo_jumper['game'] >
		foot( ): readonly(any)[]
		map( ): string
		Level( ): $bog_gamengine_demo_jumper_level
		Tile( ): $bog_gamengine_phys_tile
		Atlas( ): $bog_gamengine_atlas
		Sound( ): $bog_gamengine_sound
		Key( ): $bog_gamengine_key
		Input( ): $bog_gamengine_input
		Clock( ): $bog_gamengine_clock
		Scene( ): $bog_gamengine_scene
		Cam( ): $bog_gamengine_cam_flat
		Sky( ): $bog_gamengine_sprite
		Cell( id: any): $bog_gamengine_sprite
		Hero( ): $bog_gamengine_demo_jumper_hero
		Hero_sprite( ): $bog_gamengine_sprite
		Item( id: any): $bog_gamengine_demo_jumper_item
		Item_sprite( id: any): $bog_gamengine_sprite
		Enemy( id: any): $bog_gamengine_demo_jumper_enemy
		Enemy_sprite( id: any): $bog_gamengine_sprite
		Brain( id: any): $bog_gamengine_brain_fsm
		Walk_right( id: any): $bog_gamengine_brain_state
		Walk_left( id: any): $bog_gamengine_brain_state
	}
	
}

//# sourceMappingURL=jumper.view.tree.d.ts.map